export interface DeliveryOptions {
  id?: number;
  name: string;
  price: number;
  requiresCountryCodeInDeliveryAdress: false|string[];
  buttonText: string;
}

/**
 * Interface für Versandoptionen, die direkt von der API kommen
 * Erweitert DeliveryOptions um API-spezifische Eigenschaften
 */
export interface ApiDeliveryOptions extends DeliveryOptions {
  id: number; // In API-Responses ist die ID immer vorhanden
  active?: boolean;
  sortOrder?: number;
  createdAt?: string;
  updatedAt?: string;
}

export const deliveryValues: DeliveryOptions[] = [
  {
    id: 1,
    name: 'Versicherter Versand mit DHL Express innerhalb von Deutschland (12,30 €)',
    price: 12.3,
    requiresCountryCodeInDeliveryAdress: ['DE'],
    buttonText: "Versand"
  },
  {
    id: 2,
    name: 'Versicherter Versand mit DHL Express nach AT, BE, FR, LU, NL und IT (30,00 €)',
    price: 30.0,
    requiresCountryCodeInDeliveryAdress: ['AT', 'BE', 'FR', 'LU', 'NL', 'IT'],
    buttonText: "Versand international"
  },
  {
    id: 3,
    name: 'Abholung im Festbüro (kostenlos), spätestens 1 Tag vor dem Reservierungstag',
    price: 0.0,
    requiresCountryCodeInDeliveryAdress: false,
    buttonText: "Abholung vor Ort"
  },
];
